import React from 'react'
import { isEmpty } from 'lodash'
import formatCurrencyToBr from 'format-currency-to-br'

const Tr = (props) => {
  const renderButtonRemove = (item) => {
    return (
      <button title='Aprovar'
        onClick={() => props.onClickRemove(item.id)}
        className='button button--circle is-danger'>
        <i className='fa fa-trash' aria-hidden='true' />
      </button>
    )
  }
  const { item } = props
  return (
    <tr key={item.id} className={`tr--${item.status}`}>
      <td>{isEmpty(item.subject) ? 'Sem disciplina' : item.subject.name}</td>
      <td>{isEmpty(item.user) ? 'Sem usuário' : item.user.name}</td>
      <td>
        <img className='image' src={item.book.photo_url || `${process.env.PUBLIC_URL}/img/default_pic.png`} alt={`Capa do livro: ${item.book.name}`} />
        <a onClick={() => props.handleOpenModal(item.book.id, item.book)}> {isEmpty(item.book) ? 'Sem livro' : item.book.name} </a>
        <p><strong>Preço:</strong> {formatCurrencyToBr(item.book.product_value)}</p>
      </td>
      <td>
        { props.role === 'fractal_operator' && renderButtonRemove(item) }
      </td>
    </tr>
  )
}

export default Tr



// WEBPACK FOOTER //
// ./src/components/DataTable/Tr/index.js